import React from "react";
import { Redirect } from 'react-router-dom';
import CheckoutStep from './../Checkout/CheckoutStep.jsx';
import { CheckoutProvider } from './../Providers/CheckoutProvider'
import { Storage } from './../Core/Storage';
import { Customer } from './../Models/Customer';
import { Routes } from './../Core/Constants';
import LoginForm from '../Forms/LoginForm.jsx';
import { AppStore } from './../Core/AppStore'

export default class CheckoutCross extends React.Component {
	state = {
		pricedOrder: null,
		redirectToRegistration: false,
		customer: null
	}

	componentDidMount = () => {
		if (window.gtm) {
			window.gtm.loaded = false;
		}
		AppStore.emit('Checkout.Header', true);

		var that = this;
		let customer = Storage.instance().customer;
		if (!customer) {
			customer = new Customer();
			Storage.instance.customer = customer;
		}
	
		this.setState({ customer: customer });
		CheckoutProvider.calculate((data) => {
			window.gtm.loadCheckoutCross(data);
			that.setState({ pricedOrder: data });

		});
	}



	render = () => {
		if (this.state.redirectToRegistration) {
			return (<Redirect to={Routes.Register} />);
		}
		let T = window.Texts.checkout;		
		return (
			<div className="checkout-page">
				<div className="cover">
					<CheckoutStep Step="2" />
					<div className="checkout-inner">
						<div className="page-crossroad">
							<div className="headline">
								<h1>{T.haveAccount}</h1>
							</div>							
							<div className="box form-box without-reg">
								<a className="no-line underline" href="#" onClick={(e) => { e.preventDefault(); this.props.goUnregistered(); }}><u>{T.wantOrderWithoutRegistration}</u></a>
						    </div>						
							<div className="prow">
								<div className="pcol span-5">
									<div className="box form-box same-height flex">
										<div className="inner">
											<h2>{T.createAccount}</h2>
											<a className="btn btn50 iconed icon-continue" onClick={(e) => this.setState({redirectToRegistration:true})}>
												<span>{T.continue_}</span>
											</a>
										</div>
									</div>
								</div>								   
								<div className="pcol span-5">
									<div className="box form-box same-height">
										<h2>{T.alreadyHaveAccount}</h2>
										<LoginForm onSuccess={()=>this.props.hide()}/>													
									</div>                       
								</div>
						</div>
					</div>
					</div>
				</div>
			</div>
		);
	}
}